import React from 'react';
import styles from './PageLoader.module.scss';

// eslint-disable-next-line react/prop-types -- optional layout class from parent (e.g. embedded)
function PageLoader({ className }) {
  return (
    <div
      className={[styles.pageLoader, className].filter(Boolean).join(' ')}
      role="status"
      aria-label="Loading"
    >
      <p className={styles.text}>Loading ..</p>
    </div>
  );
}

export default PageLoader;
